export default __webpack_public_path__ + "static/media/current_founder_.b1570602.svg";